webpackJsonp([114276838955818,60335399758886],{

/***/ 146:
/***/ (function(module, exports) {

	module.exports = {"data":{"site":{"siteMetadata":{"title":"Mambo World: Beach, art and stuff","description":"","keywords":"","url":"https://www.mamboworld.com.au"}},"wordpressOptions":{"copyright":"ALL RIGHTS NO LEFTS SINCE 1984 © CAPRICE AUSTRALIA ","quote_slider":[{"text":"In the future, everyone will \u2028wear Mambo for 15 minutes","credit":"Andy Warhol "},{"text":"PAPA’S GOT A BRAND NEW MAMBO BAG","credit":"Mambo Proverb"},{"text":"DROP INS MAKE JESUS CRY ","credit":"Mambo Proverb"},{"text":"TOO MANY WAVES, TOO FEW SICK DAYS","credit":"Mambo Proverb"},{"text":"DROP IN OR TAKE-AWAY","credit":"Mambo Proverb"},{"text":"CLEAR SKIN AND GOOD TEETH ARE FLEETING BUT MAMBO IS FOREVER","credit":"Mambo Proverb"},{"text":"DON’T BELIEVE EVERYTHING YOU READ ON A TSHIRT ","credit":"Mambo Proverb"},{"text":"THANK YOU FOR ALLOWING US TO SELL YOU THONGS","credit":"TEAM MAMBO WORLD"},{"text":"NOBODY LIKES A SARCASTIC DOLPHIN","credit":"Mambo Proverb"},{"text":"BE THE MAN YOUR POODLE KNOWS YOU CAN BE","credit":"Mambo Proverb"},{"text":"STRENGTH THROUGH MAMBO ","credit":"Mambo Proverb"},{"text":"MR GORBACHEV, TEAR DOWN THIS MAMBO","credit":"Ronald Reagan"},{"text":"OOPS I DID IT AGAIN","credit":"Gary Busey"},{"text":"BUY SOMEONE’S LOVE WITH MAMBO","credit":"Mambo Proverb"},{"text":"Never hang your washing on the line of fire","credit":"Mambo Proverb"},{"text":"Never say anything unless you’re sure that everyone else is going to agree","credit":"Mambo Proverb"},{"text":"If at first you don’t succeed, lower your standards","credit":"Mambo Proverb"},{"text":"I don’t know the meaning of fear because I’m not very bright","credit":"Mambo Proverb"},{"text":"The grass is always greener around the tap","credit":"Mambo Proverb"},{"text":"No man is an island. In fact, an island is a tract of land not large enough to be called a continent ","credit":"Mambo Proverb"},{"text":"People who live in glass houses get very hot in summer","credit":"Mambo Proverb"},{"text":"Nothing can dim the light that shines from within the fridge","credit":"Mambo Proverb"},{"text":"You’re never too old to spill soup down the front of your tracksuit","credit":"Mambo Proverb"}],"mc_signup_image":"admin.mamboworld.com.au/wp-content/uploads/2018/12/MAMBO-SLIDES-6767-3-1500x844.jpg","mc_signup_text":"Slide into our mailing list for intermittent Mambo news.","meta_description_default":"Everything you need to read about beaches, art and other stuff from one of Australia’s most iconic brands and purveyors of fine beach-ready trousers. "},"wordpressContact":{"acf":{"contact_details":[{"subtitle":"For editorial inquiries","email":"mambo@caprice.com.au"},{"subtitle":"For product inquiries","email":"sales@caprice.com.au"}]}},"wordpressLanding":{"acf":{"slideshow":[{"media_type":"video","video_url":"admin.mamboworld.com.au/wp-content/uploads/2018/09/MAMBO_WORLD_PLACEHOLDER_VIDEO.mp4","image":{"sizes":{"fullwidth":"https://admin.mamboworld.com.au/wp-content/uploads/2018/09/board-print.png"}}}]}}},"layoutContext":{}}

/***/ }),

/***/ 290:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(320);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(146);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 320:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n        padding-top: 78px;\n    '], ['\n        padding-top: 78px;\n    ']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n            margin-bottom: 576px;\n        '], ['\n            margin-bottom: 576px;\n        ']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(264);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _components = __webpack_require__(18);
	
	var _reactScrollParallax = __webpack_require__(54);
	
	var _utils = __webpack_require__(5);
	
	__webpack_require__(6);
	
	__webpack_require__(42);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Layout = function Layout(_ref) {
	    var children = _ref.children,
	        data = _ref.data,
	        location = _ref.location;
	    return _react2.default.createElement(
	        SiteWrapper,
	        null,
	        _react2.default.createElement(_reactHelmet2.default, {
	            title: data.site.siteMetadata.title,
	            meta: [{ name: 'description', content: data.wordpressOptions.meta_description_default }, { name: 'keywords', content: data.site.siteMetadata.keywords }, { property: 'og:url', content: data.site.siteMetadata.url },
	            //{ property: 'og:image', content: ogProfileImage },
	            { property: 'og:title', content: data.site.siteMetadata.title }, { property: 'og:description', content: data.wordpressOptions.meta_description_default }, { property: 'twitter:card', content: 'summary' }, { property: 'twitter:title', content: data.site.siteMetadata.title }, { property: 'twitter:description', content: data.wordpressOptions.meta_description_default }]
	        }),
	        _react2.default.createElement(
	            _reactHelmet2.default,
	            null,
	            _react2.default.createElement('link', { rel: 'stylesheet', type: 'text/css', charset: 'UTF-8', href: 'https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick.min.css' }),
	            _react2.default.createElement('link', { rel: 'stylesheet', type: 'text/css', href: 'https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick-theme.min.css' })
	        ),
	        _react2.default.createElement(_components.Header, {
	            location: location,
	            contactData: data.wordpressContact
	        }),
	        _react2.default.createElement(
	            _reactScrollParallax.ParallaxProvider,
	            null,
	            children()
	        ),
	        _react2.default.createElement(_components.SignupForm, null),
	        _react2.default.createElement(_components.Competition, {
	            data: data.wordpressOptions
	        }),
	        _react2.default.createElement(_components.Footer, {
	            data: data.wordpressOptions
	        })
	    );
	};
	
	var SiteWrapper = _styledComponents2.default.div.withConfig({
	    displayName: 'layouts__SiteWrapper',
	    componentId: 'sc-1gtojat-0'
	})(['height:100%;display:flex;flex-direction:column;align-items:center;max-width:100vw;overflow-x:hidden;padding-top:140px;', ' > *:not(:first-child){width:100%;will-change:opacity;}> *:nth-child(2){background:white;margin-bottom:350px;border-bottom:2px solid black;box-sizing:border-box;', '}'], _utils.media.phone(_templateObject), _utils.media.phone(_templateObject2));
	
	exports.default = Layout;
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-js-8d408255800dbd02617f.js